import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { Button, Container } from "react-bootstrap";
import { FaFacebook, FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';

const FooterContainer = styled.div`
  background: #343a40;
  padding: 2rem 0;
  color: white;
  text-align: center;
  text-shadow: #000000 1px 1px 3px;
`;

const Footer = (props) => {
  return (
    <FooterContainer>
      <Container>
        {!props.contactPage && (<React.Fragment><p className="lead">
          Ready to improve software quality, testing, automation, and modern development practices?
        </p>
        <p>
        <Button as={Link} variant="primary" to="/subscribe">
          Subscribe
        </Button>           
        {' '}
        <Button as={Link} variant="primary" to="/contact">
          Contact Us
        </Button>
        </p></React.Fragment>)}
        <p>
        Connect with Aspiricity:
        {' '}
        <a
          href="https://www.facebook.com/aspiricity/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Aspiricity on Facebook"><FaFacebook size={24} /></a>
        {' '}
        <a
          href="https://twitter.com/aspiricity"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Aspiricity on Twitter"
        ><FaTwitter size={24} /></a>
        {' '}
        <a
          href="https://www.linkedin.com/company/aspiricity/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Aspiricity on LinkedIn"
        ><FaLinkedin size={24} /></a>
        {' '}
        <a
          href="https://www.youtube.com/channel/UCL2ITgxLyogPfshNmkOuGUw/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Aspiricity on YouTube"
        ><FaYoutube size={24} /></a>
        </p>
      </Container>
    </FooterContainer>
  );
};

export default Footer;
